import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { LAYER_LOAD, LAYER_LOADING } from "../../../MapStore2/web/client/actions/layers";
import { layerLoadingPartialReducer } from "./layer-load/layerLoading.reducer";
import { layerLoadedPartialReducer } from "./layer-load/layerLoaded.reducer";

export interface LayerLoadState {
    loadingLayerIds: string[];
    loading: boolean;
}

export const layerLoadReducer = createReducer<LayerLoadState>(
    {
        loadingLayerIds: [],
        loading: false,
    },
    { [LAYER_LOADING]: layerLoadingPartialReducer, [LAYER_LOAD]: layerLoadedPartialReducer }
);
